function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  fill: "none",
  strokeWidth: ".5"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FBFCFC",
  d: "M3.55 15V5.7c-.05-.35.25-.7.65-.7h10.4c.2 0 .35.1.5.2.15.15.2.3.2.5v6.2c0 .4-.3.7-.65.7H5.2L3.55 15zm1.9-8.1h5.85m-5.85 3.85h6.05m-6.05-1.9h4.8"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "translate(3.5 5)",
  fill: "#FBFCFC",
  cx: "11.25",
  cy: "3.75",
  r: "2.25"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14 8.95l.65.65L16 8"
})));